import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="4"
      height="4"
      fill="none"
      viewBox="0 0 4 4"
    >
      <circle cx="2" cy="2" r="2" fill="#202020" fillOpacity="0.2"></circle>
    </svg>
  )
}

export default Icon
